import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  link: {
    display: 'inherit',
  },
  linkImage: {
    height: 35,
    width: 'auto',

    '&:hover': {
      opacity: 0.3,
    },
  },
});

const UNAVAILABLE_ICON = '/assets/images/report_unavailable_25x25.png';

const BetterviewLinkCellRenderer = withStyles(styles)(({ data, classes, ...rest }) => {
  // catch in case the grid is infinite loading and loads blank rows
  if (!data) {
    return;
  }
  const hasData = (data.dataHit || '').toString().toLowerCase() !== 'no';

  return (
    <div className={classes.container}>
      {hasData ? (
      <a
        className={classes.link}
        href={`/#/quickvue-betterview-preview/${data.orderLineId}`}
        target="_blank"
        onClick={evt => {
          evt.stopPropagation();
        }}
      >
        <img
          className={classes.linkImage}
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAARVBMVEX///8Kj9wAjNsAidrM5/fC2/M0m99ktOfx+v0Ajdvq9fw5oOHZ7PkhmN/h8foNlN5Lp+Nvtuf0+v1fsOZCpeIAhNnW6vhO2PrbAAAEX0lEQVR4nO2bUXOqMBBGFa6oVNSC7f//qddoWQU2RBl3k+x856kPDHIKy5kxcbUCAAAAAAAAAAAAAAAAAAAAAAAAAAAAyNH+k+YQWbApZClPx6iC9VexFqWo4t7C+iIsuG/iCrbSd3C/jvuI7hrpR/RU/33UMcqtrCu1GTyc/sUQlJ7BJ8GqjGAo/5I59YLHa5H0DXfSj+h+3c9gff1b37AVf8k0/Vv0cNqv9Q0VQ3+4PSzahoqhvwtqGyqGvj7dP0rXUDP0V1l9Qz70+yV4BB8z2PSHaBryM7hvqvdpWMXxS0bbkBcszvXubdqOMxyE/vEBaoZ86Mtzu+BcXckJDkKvb8iHvjgvOdeWExyFXt2QD32x6A5+s4LcDCoa+mbwY4KT0Csb8qEvLx+cwXHodQ350JeLZpAVZEKvasiHvrgsOVdoBqehVDAUn0HvS0bJ8JOCbCb40OsZxgq9mmG00GsZxgu9kmHE0OsYxgy9imHU0GsYxg29gmHk0Msbxg69uGH00Esbxg+9sGECoZc1TCH0ooZJhF7SMI3QCxomEno5w+ihH69pfNoweujLbnRjP2zIh77olpxrUejLrq0kDT1r9MV2AfzDEAh9ub3+kwUNvWv0S3YWst+5BGaw/F6JGuqv0TOCkoYR1uhHgrdxlzOMsUbPCMoZam7GY0N/e0QFDVU343lnUNBQdzMeJ7jtL0XGUHkzHiPYPV2LgKH2Zryp4PZxMRKG6pvxJoLfT1cjYJhG6AUNEwm9nGEqoRczTCb0UobH6qeU5Z2XjITh70aafgZDoZcyVCMYeiJTw3DoiTwNX51BR5aGxzcE8zTccN+6cTPoMGPoEzRj6HlEV2YM/YJGDNlM/GHCcHaVwILhfnalzoJhMfOMwjBRYDgAhkkCwwEwTBIYDoBhksBwAAyTBIYDYJgkMBwAwySB4QD7hrXsPm8Z3jFsz8J79UV4x/A8Xmo0ZtieJ4s4tgzbyR00ZsgJ2jLkf6JhyHA6g+7gZskPkrR5ybC9sIJfO+2rXcIrhuwMrotLzRybHi8YegS/8hB8xZAXzGIGHUFDJvTuuCqLGXSEDPOeQUfAMH/BkCEf+iojwYChJ/TZzKBjztAX+lzeondmDA3MoMNvmHnoCb9h5qEnfIbZh57wGBqZQQdvaEjQY2gg9ARraCH0BGNoI/TE1NDSDDqmhkZCT0wMOyOhJyZ79fm3aJ4vmRvs757MzKDjBcO8BV8wzDT0RNAw19ATIcNsQ08EDDOfQce8YcahJ2YNcw49MWeYdeiJGUMDM+jwGxoR9BvmHnrCZ5h96AmPYf6hJ3hDKzPoYA0thJ7gDE2EnmAMbYSemBpamkHHxNCa4PSbKCuhJ8bfJpoJPTE0NBR6YmBobgYdz4amQk88GdoKPfEwNBZ6ggxNzqCjNzQr2BvaCz1xNzQYeuJmaDH0hDO0O4OOq6HN0BOb0mjoic2P0dATG7uZ+OP3GD4GAAAAAAAAAAAAAJjhP+fQWc87TkLRAAAAAElFTkSuQmCC"
        />
      </a>
      ) : (
        <img className={classes.linkImage} src={UNAVAILABLE_ICON} alt="" />
      )}
    </div>
  );
});

BetterviewLinkCellRenderer.propTypes = {
  classes: PropTypes.object,
  gridData: PropTypes.array,
  onSave: PropTypes.func,
};

export default BetterviewLinkCellRenderer;
